import { defineMessages } from "react-intl";

export const messages = defineMessages({
  netPrice: {
    id: "modification.translation.netPrice",
    defaultMessage: "NET PRICE",
  },
  usePoint: {
    id: "modification.translation.usePoint",
    defaultMessage: "Use point",
  },
  noRate: {
    id: "modification.translation.noRate",
    defaultMessage: "- means no rate",
  },
  deposit: {
    id: "modification.translation.deposit",
    defaultMessage: "Deposit",
  },
  extras: {
    id: "modification.translation.extras",
    defaultMessage: "Extras",
  },
  netPriceTotal: {
    id: "modification.translation.netPriceTotal",
    defaultMessage: "Total Price",
  },
  netPriceTotalHelpText: {
    id: "modification.translation.netPriceTotalHelpText",
    defaultMessage: "The amount is multiplied by the number of rooms booked",
  },
  extrasTotal: {
    id: "modification.translation.extrasTotal",
    defaultMessage: "Extras amount",
  },
  grandTotal: {
    id: "modification.translation.grandTotal",
    defaultMessage: "Booking amount",
  },
  quantity: {
    id: "modification.translation.quantity",
    defaultMessage: "Quantity",
  },
  checkIn: {
    id: "modification.translation.checkIn",
    defaultMessage: "checkIn",
  },
  checkOut: {
    id: "modification.translation.checkOut",
    defaultMessage: "checkOut",
  },
  comments: {
    id: "modification.translation.comments",
    defaultMessage: "Comments",
  },
  internalNotes: {
    id: "modification.translation.internalNotes",
    defaultMessage: "Internal Notes",
  },
  dateHeader: {
    id: "modification.translation.dateHeader",
    defaultMessage: "date",
  },
  ariPriceHeader: {
    id: "modification.translation.ariPriceHeader",
    defaultMessage: "ariPrice",
  },
  appliedPriceHeader: {
    id: "modification.translation.appliedPriceHeader",
    defaultMessage: "appliedPrice",
  },
  discountHeader: {
    id: "modification.translation.discountHeader",
    defaultMessage: "discount",
  },
  finalPriceHeader: {
    id: "modification.translation.finalPriceHeader",
    defaultMessage: "finalPrice",
  },
  restrictionsHeader: {
    id: "modification.translation.restrictionsHeader",
    defaultMessage: "restrictions",
  },
  promosHeader: {
    id: "modification.translation.promosHeader",
    defaultMessage: "promos",
  },
  insertPrice: {
    id: "modification.translation.insertPrice",
    defaultMessage: "insertPrice",
  },
  room: {
    id: "modification.translation.inventoryTicker",
    defaultMessage: "insertPrice",
  },
  day: {
    id: "modification.translation.day",
    defaultMessage: "day",
  },
  discountTooltip: {
    id: "modification.translation.discountTooltip",
    defaultMessage: "discountTooltip",
  },
  availability: {
    id: "modification.translation.messages.availability",
    defaultMessage: "availability",
  },
  stop: {
    id: "modification.translation.messages.stop",
    defaultMessage: "stop",
  },
  minStay: {
    id: "modification.translation.messages.minStay",
    defaultMessage: "minStay",
  },
  maxStay: {
    id: "modification.translation.messages.maxStay",
    defaultMessage: "maxStay",
  },
  minAdv: {
    id: "modification.translation.messages.minAdv",
    defaultMessage: "minAdv",
  },
  maxAdv: {
    id: "modification.translation.messages.maxAdv",
    defaultMessage: "maxAdv",
  },
  name: {
    id: "modification.translation.messages.name",
    defaultMessage: "name",
  },
  type: {
    id: "modification.translation.messages.type",
    defaultMessage: "type",
  },
  travelWindow: {
    id: "modification.translation.messages.travelWindow",
    defaultMessage: "tavelWindow",
  },
  bookingWindow: {
    id: "modification.translation.messages.bookingWindow",
    defaultMessage: "bookingWinndow",
  },
  multiple: {
    id: "modification.translation.messages.multiple",
    defaultMessage: "multiple",
  },
  cancel: {
    id: "app.cancel",
    description: "Cancel",
    defaultMessage: "Cancel",
  },
  ok: {
    id: "reservationDetail.payment.modal.ok",
    description: "ok",
    defaultMessage: "Ok",
  },
  confirmation: {
    id: "modification.translation.confirmation",
    description: "Are you sure you want to delete it?",
    defaultMessage: "Are you sure you want to delete it?",
  },
  cancellationPolicies: {
    id: "modification.translation.cancellationPolicies",
    description: "Cancellation Policies",
    defaultMessage: "Cancellation Policies",
  },
  cancellationRestriction: {
    id: "component.cancellationPolicies.cancellationRestriction",
    description: "Cancellation restrictions",
    defaultMessage: "Cancellation restrictions",
  },
  localHour: {
    id: "component.cancellationPolicies.localHour",
    description: "Local hour",
    defaultMessage: "Local hour",
  },
  schedule: {
    id: "component.cancellationPolicies.schedule",
    description: "Schedule",
    defaultMessage: "Schedule",
  },
  entry: {
    id: "component.cancellationPolicies.entry",
    description: "Entry",
    defaultMessage: "Entry",
  },
  exit: {
    id: "component.cancellationPolicies.exit",
    description: "Exit",
    defaultMessage: "Exit",
  },
  pets: {
    id: "component.cancellationPolicies.pets",
    description: "Pets",
    defaultMessage: "Pets",
  },
  childrenAndBeds: {
    id: "component.cancellationPolicies.childrenAndBeds",
    description: "Children and Beds",
    defaultMessage: "Children and Beds",
  },
  groups: {
    id: "component.cancellationPolicies.groups",
    description: "Groups",
    defaultMessage: "Groups",
  },
  additionalInfo: {
    id: "component.cancellationPolicies.additionalInfo",
    description: "Additional Info",
    defaultMessage: "Additional Info",
  },
  penalties: {
    id: "component.cancellationPolicies.penalties",
    description: "Penalties",
    defaultMessage: "Penalties",
  },
  dates: {
    id: "ari.management.dateRange.dates",
    description: "Dates",
    defaultMessage: "Dates",
  },
  originalExtras: {
    id: "modification.translation.messages.originalExtras",
    description: "Original Extras",
    defaultMessage: "Original Extras",
  },
  addExtras: {
    id: "modification.translation.addExtras",
    description: "Add Extras",
    defaultMessage: "Add Extras",
  },
  editExtraPrice: {
    id: "modification.translation.editExtraPrice",
    description: "Edit extra price",
    defaultMessage: "Edit extra price",
  },
  extrasModifiedWarning: {
    id: "modification.translation.extrasModifiedWarning",
    description: "Booking has been modified and the following extras will be removed",
    defaultMessage:
      "The booking has been modified and the following extras will be removed. If you wish, you can add them again for the new selection.",
  },
  extraTicker: {
    id: "modification.translation.extraTicker",
    description: "Extra Ticker",
    defaultMessage: "Extra Ticker",
  },
  extraName: {
    id: "modification.translation.extraName",
    description: "Extra Name",
    defaultMessage: "Extra Name",
  },
  extraType: {
    id: "modification.translation.extraType",
    description: "Extra Type",
    defaultMessage: "Extra Type",
  },
  unit: {
    id: "modification.translation.unit",
    description: "Unit",
    defaultMessage: "Unit",
  },
  price: {
    id: "modification.translation.price",
    description: "Price",
    defaultMessage: "Price",
  },
  total: {
    id: "modification.translation.total",
    description: "Total",
    defaultMessage: "Total",
  },
  actions: {
    id: "modification.translation.actions",
    description: "Actions",
    defaultMessage: "Actions",
  },
  unitsPerDay: {
    id: "modification.translation.unitsPerDay",
    description: "Units to enjoy per day of stay",
    defaultMessage: "Units to enjoy per day of stay",
  },
  daysOfStay: {
    id: "modification.translation.daysOfStay",
    description: "Days of stay",
    defaultMessage: "Days of stay",
  },
  unitLabel: {
    id: "modification.translation.unitLabel",
    description: "unit",
    defaultMessage: "unit",
  },
  unitDayLabel: {
    id: "modification.translation.unitDayLabel",
    description: "unit/day",
    defaultMessage: "unit/day",
  },
  unitDateLabel: {
    id: "modification.translation.unitDateLabel",
    description: "unit/date",
    defaultMessage: "unit/date",
  },
  roomLabel: {
    id: "modification.translation.roomLabel",
    description: "room",
    defaultMessage: "room",
  },
  roomDayLabel: {
    id: "modification.translation.roomDayLabel",
    description: "room/day",
    defaultMessage: "room/day",
  },
  roomDateLabel: {
    id: "modification.translation.roomDateLabel",
    description: "room/date",
    defaultMessage: "room/date",
  },
  personLabel: {
    id: "modification.translation.personLabel",
    description: "person",
    defaultMessage: "person",
  },
  personDayLabel: {
    id: "modification.translation.personDayLabel",
    description: "person/day",
    defaultMessage: "person/day",
  },
  personDateLabel: {
    id: "modification.translation.personDateLabel",
    description: "person/date",
    defaultMessage: "person/date",
  },
  confirm: {
    id: "modification.translation.confirm",
    description: "Confirm",
    defaultMessage: "Confirm",
  },
  extraNotAppliedToInventory: {
    id: "modification.translation.extraNotAppliedToInventory",
    description: "Extra is not applied to selected inventory line",
    defaultMessage: "Extra {name} is not applied to the selected inventory line.",
  },
  extraNotAvailable: {
    id: "modification.translation.extraNotAvailable",
    description: "Extra is not available",
    defaultMessage: "Extra {name} is not available.",
  },
  extraRestricted: {
    id: "modification.translation.extraRestricted",
    description: "Extra is restricted",
    defaultMessage: "Extra {name} is restricted.",
  },
  perRoom: {
    id: "modification.translation.perRoom",
    description: "Per room",
    defaultMessage: "Per room",
  },
  perPerson: {
    id: "modification.translation.perPerson",
    description: "Per person",
    defaultMessage: "Per person",
  },
  perUnit: {
    id: "modification.translation.perUnit",
    description: "Per unit",
    defaultMessage: "Per unit",
  },
  date: {
    id: "modification.translation.date",
    description: "Date",
    defaultMessage: "Date",
  },
  units: {
    id: "modification.translation.units",
    description: "Units",
    defaultMessage: "Units",
  },
  appliedRatePerExtra: {
    id: "modification.translation.appliedRatePerExtra",
    description: "Applied rate per extra",
    defaultMessage: "Applied rate per extra",
  },
  newAppliedRate: {
    id: "modification.translation.newAppliedRate",
    description: "New applied rate",
    defaultMessage: "New applied rate",
  },
  applyToAll: {
    id: "modification.translation.applyToAll",
    description: "Apply to all",
    defaultMessage: "Apply to all",
  },
  extraTotalNote: {
    id: "modification.translation.extraTotalNote",
    description: "The amount corresponds to the total of the extra",
    defaultMessage: "* The amount corresponds to the total of the extra.",
  },
  from: {
    id: "component.cancellationPolicies.from",
    description: "From",
    defaultMessage: "From",
  },
  until: {
    id: "component.cancellationPolicies.until",
    description: "Until",
    defaultMessage: "Until",
  },
  firstNight: {
    id: "component.cancellationPolicies.firstNight",
    description: "First Night",
    defaultMessage: "First Night",
  },
  insurance: {
    id: "modification.translation.insurance",
    description: "Cancellation insurance",
    defaultMessage: "Cancellation insurance",
  },
  dailyValuesDatesMismatch: {
    id: "modification.translation.dailyValuesDatesMismatch",
    description: "Daily prices dates do not match the stay dates",
    defaultMessage:
      "The daily prices dates do not match the check-in / check-out dates. Please review the stay dates and daily prices before saving.",
  },
  noRateLoadedForDates: {
    id: "modification.translation.noRateLoadedForDates",
    description: "No rate is loaded for some of the selected dates",
    defaultMessage:
      "This booking cannot be saved: there are no rates loaded for the highlighted dates. Please contact the property so they can load them.",
  },
});
